module.exports = __webpack_public_path__ + "static/media/erik.57d621cb.jpg";